import React from 'react';
import classNames from 'classnames';

import AutosuggestInput from 'components/autosuggestInput';

import classes from './index.module.css';

const reviewSubmit = (props) => {
  const { onSearch, isJobPage = false } = props;
  const text = !isJobPage
    ? 'Thanks for helping others find the right company. Help us with another company!'
    : '';

  return (
    <div
      className="d-flex flex-column align-items-center position-relative z-br-4 z-py-32 z-px-32 z-px-md-64"
      {...props}
    >
      <i className={classNames('icon-sponsors-visa', classes.icon)} />
      <div className="z-mt-16 text-center z-font-18 z-font-600">Review Submitted</div>
      <p className={classNames('z-mt-8 z-font-14 text-center', classes.subtitle)}>{text}</p>
      {!isJobPage && (
        <AutosuggestInput
          category="company"
          inputProps={{
            name: 'company',
            className: classes.search,
            placeholder: 'Company',
          }}
          onChange={onSearch}
        />
      )}
    </div>
  );
};
export default reviewSubmit;
